import { render, staticRenderFns } from "./AddCustomerType.vue?vue&type=template&id=16a91283&scoped=true&"
import script from "./AddCustomerType.vue?vue&type=script&lang=js&"
export * from "./AddCustomerType.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerType.vue?vue&type=style&index=0&id=16a91283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a91283",
  null
  
)

export default component.exports